import React, { useState } from "react";
import { array, string, func, object } from "prop-types";

import MenuItem from "../../atoms/menu-item";
import CrossIcon from "../../atoms/icons/cross-icon";
import SettingsIcon from "../../atoms/icons/settings-icon";
import ToggleTheme from "../../atoms/toggle-theme";
import Button from "../../atoms/button";
import SocialIcons from "../../molecules/social-icons";
import SearchInput from "../../atoms/SearchInput";
import PopupModal from "../../atoms/popup-modal";
import LoginView from "../../rows/login-view";
import PopupMobileLogoView from "../mobile-popup-logos";
import LinkView from "../../atoms/link-view";

import translate from "../../translate";

import "./mobilePopupMenu.m.css";

const MobilePopupMenu = ({
  items,
  pageType,
  closeClick,
  navigateToPage,
  publisherName,
  member,
  onPopupSettingsClick,
  currentHostUrl,
  currentPath,
  setUpUserFlow,
}) => {
  const [isDark, setToggleTheme] = useState(false);
  const [isLoginPopupViewOpen, setIsLoginPopupViewOpen] = useState(false);

  if (!(items && items.length)) {
    return null;
  }

  const onPopupLoginClick = () => setIsLoginPopupViewOpen(!isLoginPopupViewOpen);

  const onLoginClick = () => {
    window.dataLayer.push({
      event: "login_try",
      login_initiate_page: currentPath || "/",
      login_initiate_position: "ATF - Header",
    });

    setIsLoginPopupViewOpen(true);
  };

  const onMyProfileClick = () => {
    closeClick();
    navigateToPage("/dashboard");
  };

  const onHomeMenuClick = (e) => {
    e.preventDefault();

    closeClick();
    navigateToPage("/");
  };

  const subscribeClick = () => {
    if (isLoginPopupViewOpen) {
      setIsLoginPopupViewOpen(false);
    }

    closeClick();

    let planSelectionUrl = `/plan-selection`;

    if (publisherName !== "quint") {
      planSelectionUrl += `?utm_source=mobile_hamburgermenu&utm_medium=Internal_${
        publisherName === "fit" ? "FIT" : "HQ"
      }&utm_campaign=WebHooks&utm_content=MOBILE_HAMBERGER_MENU`;
    }

    navigateToPage(planSelectionUrl);
  };

  const loginPopupView = () => {
    if (!isLoginPopupViewOpen) {
      return null;
    }

    return (
      <PopupModal closePopup={onPopupLoginClick}>
        <LoginView closePopup={onPopupLoginClick} setUpUserFlow={setUpUserFlow} />
      </PopupModal>
    );
  };

  // View for not logged in Users
  const notLoggedInView = () => (
    <>
      <div styleName="not-logged-in-view">
        <Button content={translate(publisherName, "login")} onClick={onLoginClick} />
        <Button content={translate(publisherName, "subscribe")} onClick={subscribeClick} />
      </div>
      {loginPopupView()}
    </>
  );

  // View for logged in Users
  const loggedInView = () => (
    <div styleName="logged-in-view">
      <span styleName="profile-name">{member && (member.name || member["first-name"] || "")}</span>

      <div styleName="profile-wrapper">
        <div styleName="my-profile-link" onClick={onMyProfileClick}>
          {translate(publisherName, "my_profile")}
        </div>

        <div styleName="settings-icon-wrapper" onClick={onPopupSettingsClick}>
          <SettingsIcon />
        </div>
      </div>
    </div>
  );

  return (
    <div styleName="wrapper">
      <div styleName="theme-close-btn">
        <ToggleTheme isDark={isDark} onToggle={setToggleTheme} />
        <div styleName="cross-icon" onClick={closeClick}>
          <CrossIcon />
        </div>
      </div>

      <div styleName="mobile-logos-wrapper">
        <PopupMobileLogoView publisherName={publisherName} />
      </div>

      {publisherName === "quint" ? (member ? loggedInView() : notLoggedInView()) : null}

      <SearchInput closeClick={closeClick} isSearchIcon={true} />

      {/* Menu Links */}
      <ul>
        {/* Show Home as default */}
        <li
          className="top-navbar-home"
          styleName={`menu-item ${pageType === "home-page" ? "highlighted-menu-item" : ""}`}
        >
          <div styleName="wrapper-link" onClick={onHomeMenuClick}>
            {translate(publisherName, "home")}
          </div>
        </li>

        {items.map((item, index) => (
          <li className={`top-navbar-${index + 1}`} key={index} styleName="menu-item">
            <MenuItem
              item={item}
              isPopup={true}
              closePopup={closeClick}
              navigateToPage={navigateToPage}
              currentHostUrl={currentHostUrl}
            />
          </li>
        ))}
      </ul>

      {/* Soical Icons */}
      <div styleName="follow-us-wrapper">
        <div styleName="follow-us-name">{translate(publisherName, "follow_us_on")}</div>
        <SocialIcons />
      </div>

      {/* Footer Links */}
      <div styleName="footer-links">
        <LinkView link="/about-us" openInNewTab={false}>
          {translate(publisherName, "about_us")}
        </LinkView>
        <LinkView link="/contact-us" openInNewTab={false}>
          {translate(publisherName, "contact_us")}
        </LinkView>
        <LinkView link="/privacy-policy" openInNewTab={false}>
          {translate(publisherName, "privacy_policy")}
        </LinkView>
      </div>
    </div>
  );
};

MobilePopupMenu.propTypes = {
  items: array,
  pageType: string,
  closeClick: func,
  setUpUserFlow: func,
  publisherName: string,
  navigateToPage: func,
  member: object,
  onPopupSettingsClick: func,
  currentHostUrl: string,
  currentPath: string,
};

export default MobilePopupMenu;
